// AdminAuthShell — admin-portal wrapper around <AuthLayout>.
//
// Encapsulates the AuthLayout root + brand panel + form panel with all
// admin-flavor chrome (utility bar, wordmark + ADMIN badge, mono headline)
// pre-filled from the admin i18n register. Auth screens just wrap their
// form-side content in <AdminAuthShell>{form}</AdminAuthShell>.
//
// Portal selection is automatic — the admin SPA is already wrapped in
// <PortalProvider portal="admin"> at the root (see App.tsx), so AuthLayout
// reads portal from context. We don't pass `portal="admin"` explicitly
// here; that would be redundant and would re-introduce the prop-threading
// pattern this shell exists to avoid.

import type { ReactNode } from 'react';
import { AuthLayout } from '@gc-coach/design-system';
import { useI18n } from '../i18n/index.js';

export interface AdminAuthShellProps {
  children: ReactNode;
}

export function AdminAuthShell({ children }: AdminAuthShellProps) {
  const { t } = useI18n();

  return (
    <AuthLayout
      utilityBarLeft={t('brand.utilityBarLeft')}
      utilityBarRight={t('brand.utilityBarRight')}
    >
      <AuthLayout.Brand
        wordmark={t('brand.wordmark')}
        wordmarkBadge={t('brand.wordmarkBadge')}
        wordmarkSub={t('brand.wordmarkSub')}
        eyebrow={t('brand.eyebrow')}
        headline={t('brand.headline')}
        tagline={t('brand.tagline')}
        footerLeft={t('brand.footerLeft')}
        footerRight={t('brand.footerRight')}
        monoHeadline
      />
      <AuthLayout.Form>{children}</AuthLayout.Form>
    </AuthLayout>
  );
}
